module.exports = __webpack_public_path__ + "images/feature/feature_1220_1-8b544c4cb757fa2da67e4d88ee29edc2.png";